import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 36);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const goSection = (id) => {
    setMobileOpen(false);
    if (isHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  };

  const navLinks = [
    { label: 'About',    action: () => goSection('about') },
    { label: 'Services', action: () => goSection('services') },
    { label: 'Why Us',   action: () => goSection('why') },
    { label: 'Team',     action: () => goSection('team') },
    { label: 'Contact',  action: () => goSection('contact') },
  ];

  return (
    <>
      <nav className={`navbar${scrolled || !isHome ? ' scrolled' : ''}`}>
        <Link to="/" className="nav-logo" onClick={() => setMobileOpen(false)}>
          <div className="nav-logo-mark"><span>K</span></div>
          <div className="nav-logo-text">
            <strong>KELWA TECHNOLOGIES</strong>
            <small>Private Limited</small>
          </div>
        </Link>

        <ul className="nav-links">
          {navLinks.map(({ label, action }) => (
            <li key={label}><a onClick={action}>{label}</a></li>
          ))}
          <li>
            <a className="nav-cta" onClick={() => goSection('contact')}>Get In Touch</a>
          </li>
        </ul>

        <button className="nav-hamburger" onClick={() => setMobileOpen(true)}>
          <span /><span /><span />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu${mobileOpen ? ' open' : ''}`}>
        <button className="mobile-close" onClick={() => setMobileOpen(false)}>✕</button>
        <Link to="/" onClick={() => setMobileOpen(false)}>Home</Link>
        {navLinks.map(({ label, action }) => (
          <a key={label} onClick={action}>{label}</a>
        ))}
      </div>
    </>
  );
}
